import React from 'react';

import { Box, Dialog } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import CloseIcon from '@mui/icons-material/Close';

import { useRegisterDismissLayer } from '../../../context/BackLayerStackContext';
import { useWindowSize } from '../../../hooks/use-window-size';
import { useStyles } from './AppDialog.styles';

const AppDialog = (props) => {
  const {
    children,
    open,
    onClose,
    title,
    classes: customClasses = {},
    hideCloseButton = false,
    disableDismiss = false,
  } = props;
  const { mobileView } = useWindowSize();
  const theme = useTheme();

  const { classes } = useStyles(theme);

  useRegisterDismissLayer(open && !disableDismiss, onClose);

  return (
    <Dialog
      fullScreen={mobileView}
      open={open}
      onClose={disableDismiss ? undefined : onClose}
      disableEscapeKeyDown={disableDismiss}
      classes={{ paper: customClasses.root || classes.appDialogWrapper }}>
      <div className={classes.appDialogHeader}>
        <div className={classes.appDialogHeaderTitle}>{title}</div>
        {hideCloseButton ? null : <CloseIcon onClick={onClose} />}
      </div>
      <Box className={classes.appDialogContentWrapper}>
        <Box className={classes.appDialogContent}>{children}</Box>
      </Box>
    </Dialog>
  );
};

export default AppDialog;
